export interface IRegionLayoutModelConfig {
  ja: string;
  zh: string;
  modelIds: string[];
  isGroup: boolean;
  key: string;
}
export const regionLayoutModelConfig: Record<string, IRegionLayoutModelConfig[]> = {
  'workspace-standard': [
    {
      ja: '4人用個人口ッカー',
      zh: '4人用储物柜',
      modelIds: ['L6'],
      isGroup: false,
      key: 'L6'
    },
    {
      ja: '8人用個人口ッカー',
      zh: '8人用储物柜',
      modelIds: ['L7'],
      isGroup: false,
      key: 'L7'
    },
    {
      ja: '3 段ラテラルキャビネット',
      zh: '矮储物柜',
      modelIds: ['L9'],
      isGroup: false,
      key: 'L9'
    },
    {
      ja: 'ハイキャビネット',
      zh: '高储物柜',
      modelIds: ['L10'],
      isGroup: false,
      key: 'L10'
    },
    {
      ja: '複合機+シュレッダー',
      zh: '打印机+碎纸机',
      modelIds: ['D2', 'D1'],
      isGroup: true,
      key: 'GROUP-1'
    }
  ],
  'workspace-abw': [
    {
      ja: '両面連結デスク（6 人用・ABW 仕様）',
      zh: '双面连接式办公桌（6人用·ABW规格）',
      modelIds: ['T9'],
      isGroup: false,
      key: 'T9'
    },
    {
      ja: '両面連結ハイデスク（6 人用・ABW 仕様）',
      zh: '双面连接办公桌高桌-6人',
      modelIds: ['T10'],
      isGroup: false,
      key: 'T10'
    },
    {
      ja: '両面デスク（2人用・ABW 仕様）',
      zh: '双面单体办公桌-2人',
      modelIds: ['T11'],
      isGroup: false,
      key: 'T11'
    },
    {
      ja: '片面連結デスク（3人用・ABW 仕様）',
      zh: '单面连接办公桌-3人',
      modelIds: ['T12'],
      isGroup: false,
      key: 'T12'
    },
    {
      ja: '片面連結ハイデスク（3人用・ABW 仕様）',
      zh: '单面连接办公桌高桌-3人',
      modelIds: ['T13'],
      isGroup: false,
      key: 'T13'
    },
    {
      ja: '片面デスク（1人用・ABW 仕様）',
      zh: '单面单体办公桌-1人',
      modelIds: ['T14'],
      isGroup: false,
      key: 'T14'
    },
    {
      ja: 'アクセントワークデスク',
      zh: '特色办公桌',
      modelIds: ['T16'],
      isGroup: false,
      key: 'T16'
    },
    {
      ja: 'アクセントワークデスク（三角形）',
      zh: '三角特色办公桌',
      modelIds: ['T24'],
      isGroup: false,
      key: 'T24'
    },
    {
      ja: '防音ワークブース 1',
      zh: '单人隔音工作间-侧边开口',
      modelIds: ['W1'],
      isGroup: false,
      key: 'W1'
    },
    {
      ja: '防音ワークブース 2',
      zh: '单人隔音工作间-背面开口',
      modelIds: ['W2'],
      isGroup: false,
      key: 'W2'
    },
    {
      ja: '防音ワークブース 3',
      zh: '单人隔音工作间-3人',
      modelIds: ['W3'],
      isGroup: false,
      key: 'W3'
    },
    {
      ja: '防音ワークブース 4',
      zh: '单人隔音工作间-1人',
      modelIds: ['W4'],
      isGroup: false,
      key: 'W4'
    },
    {
      ja: '個室ブース（1人用）',
      zh: '网络会议单间',
      modelIds: ['W6'],
      isGroup: false,
      key: 'W6'
    },
    {
      ja: '個室ブース（2人用）',
      zh: '网络会议双人间',
      modelIds: ['W7'],
      isGroup: false,
      key: 'W7'
    },
    {
      ja: '個室ブース（4人用）',
      zh: '网络会议四人间',
      modelIds: ['W8'],
      isGroup: false,
      key: 'W8'
    },
    {
      ja: 'ソファ 2',
      zh: '无扶手沙发3人',
      modelIds: ['S2'],
      isGroup: true,
      key: 'GROUP-2'
    },
    {
      ja: 'プランター付きラウンドソファ',
      zh: '绿植环绕沙发',
      modelIds: ['S4'],
      isGroup: true,
      key: 'GROUP-3'
    },
    {
      ja: '4人用個人口ッカー',
      zh: '4人用储物柜',
      modelIds: ['L6'],
      isGroup: false,
      key: 'L6'
    },
    {
      ja: '8人用個人口ッカー',
      zh: '8人用储物柜',
      modelIds: ['L7'],
      isGroup: false,
      key: 'L7'
    },
    {
      ja: '3 段ラテラルキャビネット',
      zh: '矮文件柜',
      modelIds: ['L9'],
      isGroup: false,
      key: 'L9'
    },
    {
      ja: 'ハイキャビネット',
      zh: '高文件柜',
      modelIds: ['L10'],
      isGroup: false,
      key: 'L10'
    },
    {
      ja: '複合機+シュレッダー',
      zh: '打印机+碎纸机',
      modelIds: ['D2', 'D1'],
      isGroup: true,
      key: 'GROUP-4'
    },
    {
      ja: '植栽1',
      zh: '植物',
      modelIds: ['G1'],
      isGroup: false,
      key: 'G1'
    },
    {
      ja: '植栽2',
      zh: '\n盆栽绿植-琴叶榕',
      modelIds: ['G2'],
      isGroup: false,
      key: 'G2'
    },
    {
      ja: '植栽3',
      zh: '盆栽绿植-发财树',
      modelIds: ['G3'],
      isGroup: false,
      key: 'G3'
    },
    {
      ja: '植栽4',
      zh: '盆栽绿植-发财树',
      modelIds: ['G4'],
      isGroup: false,
      key: 'G4'
    },
    {
      ja: '植栽5',
      zh: '盆栽绿植-龟背竹\n',
      modelIds: ['G5'],
      isGroup: false,
      key: 'G5'
    }
  ],
  discuss: [
    {
      ja: 'ビッグミーティングテーブル',
      zh: '协作大会议桌',
      modelIds: ['T5'],
      isGroup: false,
      key: 'T5'
    },
    {
      ja: '楕円型ミーティングデーブル',
      zh: '椭圆会议桌',
      modelIds: ['T6'],
      isGroup: false,
      key: 'T6'
    },
    {
      ja: '台形テーブル',
      zh: '可移动待滑轮梯形桌子',
      modelIds: ['T27'],
      isGroup: false,
      key: 'T27'
    },
    {
      ja: '角形ハイテーブル（キャスター付き）',
      zh: '带移动滚轮的高桌',
      modelIds: ['T28'],
      isGroup: false,
      key: 'T28'
    },
    {
      ja: '正方形テーブル（キャスター付き）',
      zh: '带移动滚轮的正方形桌',
      modelIds: ['T29'],
      isGroup: false,
      key: 'T29'
    },
    {
      ja: '半個室ブース（4 人用）',
      zh: '双人讨论会议间',
      modelIds: ['W5'],
      isGroup: false,
      key: 'W5'
    },
    {
      ja: '個室ブース（1人用）',
      zh: '网络会议单间',
      modelIds: ['W6'],
      isGroup: false,
      key: 'W6'
    },
    {
      ja: '個室ブース（2人用）',
      zh: '网络会议双人间',
      modelIds: ['W7'],
      isGroup: false,
      key: 'W7'
    },
    {
      ja: '個室ブース（4人用）',
      zh: '网络会议四人间',
      modelIds: ['W8'],
      isGroup: false,
      key: 'W8'
    },
    {
      ja: '4人用個人口ッカー',
      zh: '4人用储物柜',
      modelIds: ['L6'],
      isGroup: false,
      key: 'L6'
    },
    {
      ja: '8人用個人口ッカー',
      zh: '8人用储物柜',
      modelIds: ['L7'],
      isGroup: false,
      key: 'L7'
    },
    {
      ja: '3 段ラテラルキャビネット',
      zh: '矮文件柜',
      modelIds: ['L9'],
      isGroup: false,
      key: 'L9'
    },
    {
      ja: 'ハイキャビネット',
      zh: '高文件柜',
      modelIds: ['L10'],
      isGroup: false,
      key: 'L10'
    },
    {
      ja: '複合機+シュレッダー',
      zh: '打印机+碎纸机',
      modelIds: ['D2', 'D1'],
      isGroup: true,
      key: 'GROUP-5'
    },
    {
      ja: '植栽1',
      zh: '植物',
      modelIds: ['G1'],
      isGroup: false,
      key: 'G1'
    },
    {
      ja: '植栽2',
      zh: '盆栽绿植-琴叶榕',
      modelIds: ['G2'],
      isGroup: false,
      key: 'G2'
    },
    {
      ja: '植栽3',
      zh: '盆栽绿植-发财树',
      modelIds: ['G3'],
      isGroup: false,
      key: 'G3'
    },
    {
      ja: '植栽4',
      zh: '盆栽绿植-发财树',
      modelIds: ['G4'],
      isGroup: false,
      key: 'G4'
    },
    {
      ja: '植栽5',
      zh: '盆栽绿植-龟背竹',
      modelIds: ['G5'],
      isGroup: false,
      key: 'G5'
    }
  ],
  rest: [
    {
      ja: '正方形テーブル（ボックス脚）',
      zh: '方桌',
      modelIds: ['T20'],
      isGroup: false,
      key: 'T20'
    },
    {
      ja: '丸テーブル（ボックス脚）',
      zh: '圆桌',
      modelIds: ['T21'],
      isGroup: false,
      key: 'T21'
    },
    {
      ja: 'ソファ 2\n',
      zh: '无扶手沙发3人',
      modelIds: ['S2'],
      isGroup: true,
      key: 'GROUP-6'
    },
    {
      ja: 'ソファセット (２台)',
      zh: '沙发组合（2个沙发）',
      modelIds: ['S1', 'S3'],
      isGroup: true,
      key: 'GROUP-7'
    },
    {
      ja: 'ソファセット (３台)',
      zh: '沙发组合（3个沙发）',
      modelIds: ['S1', 'S3', 'S3', 'C10-1', 'C10-1'],
      isGroup: true,
      key: 'GROUP-8'
    },
    {
      ja: 'オープンシェルフ (3x2)',
      zh: '开放式置物架（3x2）',
      modelIds: ['L3'],
      isGroup: false,
      key: 'L3'
    },
    {
      ja: 'オープンシェルフ (4x3)',
      zh: '开放式置物架（4x3）',
      modelIds: ['L4'],
      isGroup: false,
      key: 'L4'
    },
    {
      ja: '4人用個人口ッカー',
      zh: '4人用储物柜',
      modelIds: ['L6'],
      isGroup: false,
      key: 'L6'
    },
    {
      ja: '8人用個人口ッカー',
      zh: '8人用储物柜',
      modelIds: ['L7'],
      isGroup: false,
      key: 'L7'
    },
    {
      ja: '3 段ラテラルキャビネット',
      zh: '矮文件柜',
      modelIds: ['L9'],
      isGroup: false,
      key: 'L9'
    },
    {
      ja: 'ハイキャビネット',
      zh: '高文件柜',
      modelIds: ['L10'],
      isGroup: false,
      key: 'L10'
    },
    {
      ja: 'カフェカウンター（L 型）',
      zh: '咖啡吧台',
      modelIds: ['R2'],
      isGroup: false,
      key: 'R2'
    },
    {
      ja: 'カフェカウンター（コ型）',
      zh: '咖啡吧台',
      modelIds: ['R3'],
      isGroup: false,
      key: 'R3'
    },
    {
      ja: '植栽1',
      zh: '植物',
      modelIds: ['G1'],
      isGroup: false,
      key: 'G1'
    },
    {
      ja: '植栽2',
      zh: '盆栽绿植-琴叶榕',
      modelIds: ['G2'],
      isGroup: false,
      key: 'G2'
    },
    {
      ja: '植栽3',
      zh: '盆栽绿植-发财树',
      modelIds: ['G3'],
      isGroup: false,
      key: 'G3'
    },
    {
      ja: '植栽4',
      zh: '盆栽绿植-发财树',
      modelIds: ['G4'],
      isGroup: false,
      key: 'G4'
    },
    {
      ja: '植栽5',
      zh: '盆栽绿植-龟背竹',
      modelIds: ['G5'],
      isGroup: false,
      key: 'G5'
    }
  ]
} as const;
